import React, { Component } from 'react'
import Fade from 'react-reveal/Fade'

export class HeroArea extends Component {
    render() {
        return (
            <section className="hero-area">
                <div className="container">
                    <div className="row justify-content-center">
                    <div className="col-lg-6 order-lg-2">
                        <Fade right>
                            <div className="hero-image">
                                <img src={require("../../assets/image/PP-HERO-HOLTEKAMP.png")} alt="" />
                            </div>
                        </Fade>
                    </div>
                    <div className="col-lg-6 order-lg-1">
                            <div className="hero-content">
                                <h1>Digital Construction Hack 2019</h1>
                                <p>Are you interested in digital and construction? 
                                    Wants to solve the challenge in the construction area with digital? 
                                    Come and join our first hackathon.</p>
                            </div>
                    </div>
                    </div>

                </div>
            </section>
        )
    }
}

export default HeroArea
